import React from 'react';
export const SlateKitContext = React.createContext({
    kit: null,
    mode: 'live',
    context: {},
    revertSlateUpdatesById: () => { },
    selectBlock: () => { },
    setMode: () => { },
    setSlateUpdates: () => { },
    unselectBlock: () => { },
    updateActiveBlock: () => { },
    setActiveBlocks: () => { },
    pushActiveBlock: () => { },
    popActiveBlock: () => { },
    updateSlateById: () => { },
});
export const useSlateKit = () => {
    const context = React.useContext(SlateKitContext);
    return context;
};
//# sourceMappingURL=slate-kit.hook.js.map